{
    "name": "rail-performance",
    "version": "2025.2.0",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --host=localhost --configuration=development",
        "build": "ng build",
        "build:prod": "ng build --configuration production",
        "build:preprod": "ng build --configuration preprod",
        "build:qa": "ng build --configuration qa",
        "build:dev": "ng build --configuration dev",
        "build:analyze": "ng build --stats-json && esbuild-visualizer --metadata dist/rail-performance/stats.json --open",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "lint": "ng lint",
        "e2e": "ng e2e"
    },
    "private": true,
    "engines": {
        "node": "^22.22.3 || ^24.15.0",
        "npm": ">=11.0.0"
    },
    "overrides": {
        "exceljs": {
            "uuid": "11.1.1"
        },
        "@ngneat/query": {
            "@angular/core": "$@angular/core"
        },
        "@ngneat/query-devtools": {
            "@angular/core": "$@angular/core"
        },
        "angular-svg-icon-preloader": {
            "@angular/core": "$@angular/core",
            "@angular/common": "$@angular/common",
            "@angular/platform-browser-dynamic": "$@angular/platform-browser-dynamic"
        }
    },
    "dependencies": {
        "@angular/animations": "22.2.2",
        "@angular/common": "22.2.2",
        "@angular/compiler": "22.2.2",
        "@angular/core": "22.2.2",
        "@angular/forms": "22.2.2",
        "@angular/localize": "22.2.2",
        "@angular/platform-browser": "22.2.2",
        "@angular/platform-browser-dynamic": "22.2.2",
        "@angular/router": "22.2.2",
        "@arcgis/core": "^5.1.24",
        "@auth0/auth0-angular": "^2.13.0",
        "@fortawesome/angular-fontawesome": "^5.1.0",
        "@fortawesome/fontawesome-svg-core": "^7.3.1",
        "@fortawesome/free-brands-svg-icons": "^7.3.1",
        "@fortawesome/free-regular-svg-icons": "^7.3.1",
        "@fortawesome/free-solid-svg-icons": "^7.3.1",
        "@ngneat/query": "^3.4.0",
        "@ngneat/query-devtools": "^2.1.0",
        "@ngneat/svg-icon": "^8.0.0",
        "@popperjs/core": "^2.11.8",
        "@progress/kendo-angular-buttons": "25.2.0",
        "@progress/kendo-angular-charts": "25.2.0",
        "@progress/kendo-angular-common": "25.2.0",
        "@progress/kendo-angular-dateinputs": "25.2.0",
        "@progress/kendo-angular-dialog": "25.2.0",
        "@progress/kendo-angular-dropdowns": "25.2.0",
        "@progress/kendo-angular-excel-export": "25.2.0",
        "@progress/kendo-angular-grid": "25.2.0",
        "@progress/kendo-angular-icons": "25.2.0",
        "@progress/kendo-angular-inputs": "25.2.0",
        "@progress/kendo-angular-intl": "25.2.0",
        "@progress/kendo-angular-l10n": "25.2.0",
        "@progress/kendo-angular-label": "25.2.0",
        "@progress/kendo-angular-layout": "25.2.0",
        "@progress/kendo-angular-listview": "25.2.0",
        "@progress/kendo-angular-notification": "25.2.0",
        "@progress/kendo-angular-popup": "25.2.0",
        "@progress/kendo-angular-toolbar": "25.2.0",
        "@progress/kendo-angular-tooltip": "25.2.0",
        "@progress/kendo-data-query": "^1.7.4",
        "@progress/kendo-drawing": "^1.25.6",
        "@progress/kendo-licensing": "^1.7.2",
        "@progress/kendo-svg-icons": "^4.11.0",
        "@progress/kendo-theme-default": "^14.5.0",
        "@schematics/angular": "^22.2.2",
        "@sentry/angular": "^11.0.0",
        "@tanstack/query-core": "^5.104.1",
        "angular-fusioncharts": "file:./src/assets/angular-fusioncharts",
        "angular-svg-icon": "^19.1.1",
        "angular-svg-icon-preloader": "^19.2.0",
        "bootstrap": "^5.3.8",
        "chart.js": "^4.5.1",
        "chartjs-chart-geo": "^4.3.6",
        "color-scales": "^3.0.2",
        "date-fns": "^4.4.0",
        "exceljs": "^4.4.0",
        "file-saver": "^2.0.5",
        "fusioncharts": "^3.23.0",
        "fusionmaps": "^4.0.2",
        "lodash": "^4.18.1",
        "mixpanel-browser": "^2.81.0",
        "rxjs": "~7.8.2",
        "sort-by-typescript": "^1.2.5",
        "subsink": "^1.0.2",
        "svg-to-ts": "^12.0.0",
        "tslib": "^2.0.0",
        "zone.js": "~0.16.3"
    },
    "devDependencies": {
        "@angular/build": "^22.2.2",
        "@angular/cli": "22.2.2",
        "@angular/compiler-cli": "22.2.2",
        "@juggle/resize-observer": "^3.4.0",
        "@types/file-saver": "^2.0.7",
        "@types/lodash": "^4.17.26",
        "@types/mixpanel-browser": "^2.66.0",
        "@types/node": "^26.2.0",
        "esbuild-visualizer": "^0.7.0",
        "eslint": "^10.11.0",
        "istanbul-lib-instrument": "^6.0.3",
        "jsdom": "^30.1.2",
        "typescript": "~6.0.3",
        "vitest": "^4.1.11"
    }
}
